export default __webpack_public_path__ + "static/media/marker_filled_yellow.db29605a.svg";